import { render, staticRenderFns } from "./StandardFieldsSelectList.vue?vue&type=template&id=8149f730&scoped=true&"
import script from "./StandardFieldsSelectList.vue?vue&type=script&lang=ts&"
export * from "./StandardFieldsSelectList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8149f730",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VDataTable,VIcon,VRadioGroup})
